/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Publish_DoneInputs */

const cs_property_publish_done = /** @type {(inputs: Property_Publish_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikováno na webu.`)
};

const en_property_publish_done = /** @type {(inputs: Property_Publish_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published on the website.`)
};

/**
* | output |
* | --- |
* | "Published on the website." |
*
* @param {Property_Publish_DoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_publish_done = /** @type {((inputs?: Property_Publish_DoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Publish_DoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_publish_done(inputs)
	return cs_property_publish_done(inputs)
});